module.exports = __webpack_public_path__ + "static/img/yzbg.167bd59a.png";